import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import template from './BackButton.vue';
import { router } from '@/_helpers/router';

@Component({
	mixins: [template]
})
export default class BackButton extends Vue {
	@Prop() content!: string;

	@Prop() to!: string;

	goBack(): void {
		router.push({ name: this.to || 'overview' });
	}
}
